module.exports = __webpack_public_path__ + "img/thumb_up_colored.342eae67.png";